/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

import {FirebaseStorageClient} from "@qwoach/firebase-data-manager";
import QwoachFile from "@shared/Drive/QwoachFile";
import {plainToClass, classToPlain} from "@qwoach/class-transformer-wrapper"
import asyncPool from "tiny-async-pool";

const fbPathsConfig = {
	//private paths
	storageUploadFileDrive:		["users/{{this.coachId}}/drive"],


	//api
	apiPostCreateQwoachFile: 	["api/drive/qwoachFile/create", QwoachFile],
	apiPostCopyFiles:	 		["api/drive/copy", QwoachFile],
	// apiPostMoveFiles:	 		["api/drive/move", QwoachFile], //performing on client
	// apiPostMoveToTrash:	 		["api/drive/moveToTrash", QwoachFile], //performing on client
	apiPostDeleteForeverFiles:	["api/drive/deleteForever", QwoachFile],
	apiPostRenameFile:			["api/drive/rename"]


}





/**
 *
 * @property { function(userId) } getUserProfile
 * @property { function(userItem) } updateUserProfile
 * @property { function(userItem) } setUserProfile
 * @property { function(userItem) } createUserProfile
 * @property { function(userItem) } deleteUserProfile
 *
 *

 *
 *
 * @property { function({scheduledEvent}) } apiPostEventCreate

 *
 */


export default class QwoachStorageManager extends FirebaseStorageClient{

	coachId;

	auth
	store

	constructor(firebase, store) {
		//WARNING !! it's very important to pass local 'plainToClass' function so the library can correctly transform nested objects
		//unless before class-transform fixes a problem where it can't transform nested objects when used from npm package
		// github issue: https://github.com/typestack/class-transformer/issues/313
		super(firebase, fbPathsConfig, getApiDomain(), plainToClass, classToPlain, { excludePrefixes: ["_"] });
		this.auth = firebase.auth()
		this.store = store
		console.log("QwoachStorageManager = ", this)

	}

	async uploadFileArray(qwoachFileArray, fileUploadedCallback){
		console.log("uploadFileArray start: qwoachFileArray = ", qwoachFileArray)
		// let files = qwoachFileArray.filter(qwoachFile => qwoachFile.isFile())

		await asyncPool(2, qwoachFileArray, this.uploadFilePoolWrapper(fileUploadedCallback));
		return  qwoachFileArray
	}


	progressCallback(qwoachFile, fileUploadedCallback = () => {}){
		return (progress, state, uploadTask) => {
			progress = Math.floor(progress)
			console.log("progressCallback: progress = ", progress, ", state = ", state, ", qwoachFile = ", qwoachFile)
			switch (state) {
				case "cancelled":
					qwoachFile._uploadInfo.setCancelled()
					break
				case "completed":
					// qwoachFile._uploadInfo.setCompleted()
					qwoachFile._uploadInfo.setCompletedFinalizing()
					break
				case "running":
				case "progress":
					qwoachFile._uploadInfo.setProgress(progress)
					qwoachFile._uploadInfo.setInProgress()
					fileUploadedCallback(qwoachFile)
					break
				case "error":
					qwoachFile._uploadInfo.setError()
					break
				case "pause":
					qwoachFile._uploadInfo.setPaused()
					break
			}
			if(qwoachFile._uploadInfo.isCancelled()
				|| qwoachFile._uploadInfo.isCompleted()
				|| qwoachFile._uploadInfo.isCompletedFinalizing()){
				qwoachFile._uploadInfo.uploadTask = null
			} else if(qwoachFile._uploadInfo.uploadTask !== uploadTask){
				qwoachFile._uploadInfo.uploadTask = uploadTask
			}


		}
	}

	uploadFilePoolWrapper(fileUploadedCallback = async () => {}){
		return async (qwoachFile) => {
			console.log("uploadFilePoolWrapper: qwoachFile = ", qwoachFile)
			if(qwoachFile.isFolder){
				await fileUploadedCallback(qwoachFile)
			} else if(!qwoachFile._uploadInfo.isCancelled()){
				if(!qwoachFile.ownerId){
					qwoachFile.ownerId = this.ownerId //required for security rules and further reference on the server
				}
				let metadata = await this.uploadFile(
					qwoachFile.path,
					qwoachFile._file,
					qwoachFile.createStorageMetadata(),
					this.progressCallback(qwoachFile, fileUploadedCallback)
				)
				console.log("metadata = ", metadata)
				this.applyMetadata(qwoachFile, metadata)
				await fileUploadedCallback(qwoachFile)
				return metadata
			}
		}
	}

	applyMetadata(qwoachFile, metadata){
		console.log("applyMetadata: metadata = ", metadata, ", qwoachFile = ", qwoachFile)
		if(metadata){
			qwoachFile.url = metadata.downloadUrl
			qwoachFile.size = Number(metadata.size )
		}
	}

	async uploadCompleted(parentFile, {fileRef, metadata}){
		return await this.apiPostCreateQwoachFile({metadata, parentFile})
	}

	// getFunnelItem(){
	// 	return this.getFunnelListRef()
	// 		.limit(1)
	// 		.get()
	// 		.then(res => this.resToData(res, OldFunnelItem))
	// 		.then(funnel => {
	// 			console.log("getFunnelItem = ", funnel)
	// 			return funnel;
	// 		})
	// }

}
function getApiDomain(){
	return process.env.VUE_APP_DOMAIN_API || process.env.VUE_APP_DOMAIN
}
